import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import classNames from 'classnames';
import Popup from 'popup/Popup';
import MainPopup from '../MainPopup';
import AreaInfoEditPopup from './AreaInfoEditPopup';
import { BoardContainer } from './StatusComponentBoard.css.js';
import usePrevious from 'utils/customHook/usePrevious';
import useCancellationToken from 'utils/customHook/useCancellationToken';
import { getYMDAndTimeFormatDate } from 'utils/getCustomFormatDate';
import { nvl } from 'utils/nvl';
import { moduleScnMap } from 'utils/code';
import { statusConverterForWhiteBackground } from 'utils/statusConverter';
import columnData from './columnData';

const StatusBoard = (props) => {
  const cancellationToken = useCancellationToken();
  const dispatch = useDispatch();
  const [statusPopupOn, setStatusPopupOn] = useState(false);
  const [warningTime, setWarningTime] = useState(null);
  const prevAmount = usePrevious(props.status, cancellationToken.isCancelled);
  const theme = useSelector((state) => state.mainSetting1.board.theme);
  const columnSetting = useSelector((state) => state.mainSetting1.board.columns);

  useEffect(() => {
    if (cancellationToken.isCancelled) {
      return;
    }

    if (props.status !== 'blue' && props.status !== prevAmount) {
      setWarningTime(getYMDAndTimeFormatDate(new Date(props.rgstDt)));
    } else if (props.status === 'blue' && props.status !== prevAmount) {
      setWarningTime(null);
    }
  }, [props.status]);

  // 위험알람 hooks 로직
  useEffect(() => {
    if (nvl(prevAmount, null) !== null) {
      if (props.status !== 'blue' && prevAmount !== props.status) {
        if (props.status !== 'none') {
          dispatch({ type: 'ALERT_INSERT', data: { ...props, userPhone: '', confirm: true } });
          dispatch({ type: 'ALERT_ON' });
        }
      }
    }
  }, [prevAmount, props.status, cancellationToken]);

  useEffect(() => () => cancellationToken.cancel(), []);

  const wrapperRef = useRef(null);
  const handleIconRightClick = (e) => {
    setStatusPopupOn((statusPopupOn) => {
      return !statusPopupOn;
    });

    e.preventDefault();
  };

  return (
    <>
      <Popup
        trigger={
          <BoardContainer status={props.status} theme={theme} ref={wrapperRef} onContextMenu={handleIconRightClick}>
            {columnSetting.map((column) => {
              const relayFlag = !props.fwVersion ? props.statusCode : props.relayFlag === 2 ? '1' : '0'; // props.relayFlag.toString();
              
              return columnData(relayFlag)[column].td(props);
              
            })}
          </BoardContainer>
        }
        modal
        closeOnDocumentClick
        onOpen={() => {
          dispatch({ type: 'ALERT_OFF' });
        }}
      >
        <div style={{ background: `#272F3C`, borderRadius: `10px`, padding: `10px` }}>
          <div style={{ display: `flex`, justifyContent: `center`, alignItems: `center`, fontSize: `35px` }}>
            {moduleScnMap[props.moduleScn].viewTitle} / &nbsp;
            {props.modelNm}
          </div>
          <MainPopup {...props} />
        </div>
      </Popup>
      <AreaInfoEditPopup
        moduleIdx={props.moduleIdx}
        modelNm={props.modelNm}
        areaNo={props.areaNo}
        areaNm={props.areaNm}
        statusPopupOn={statusPopupOn}
        setStatusPopupOn={setStatusPopupOn}
      />
    </>
  );
};

export default StatusBoard;
